/* ============================================================
   Yummii Yummii — quiz-lead: mailformular + konverteringssporing
   ES5, ingen afhaengigheder, intet byggetrin.

   Hvorfor en selvstaendig fil: yy-quiz.js ligger paa ~37 KB mod et
   upload-loft omkring 40 KB. Vokser motoren, kan den slet ikke
   deployes. Motoren kalder derfor kun window.YYQuizLead.block(ctx)
   og faar et faerdigt element tilbage — formular, validering,
   backend-kald og al sporing lever her.

   Resultatet gates IKKE. Kunden ser sin plastprofil foerst, og
   formularen staar under den. Vi viser svaret, og saa spoerger vi.

   Butikken koerer NEW_CUSTOMER_ACCOUNTS (passwordless). Vi kan derfor
   ikke logge kunden ind herfra og forsoeger det ikke: backenden
   opretter kunden og saetter custom.quiz_completed, saa gaven ligger
   klar, og mailens knap sender dem til kontosiden, hvor Shopify selv
   sender engangskoden.
   ============================================================ */
window.YYQuizLead = (function(){
  "use strict";
  /* Tekster fra sprogfilerne (yy.quiz.*), udskrevet som window.YYQ_T af
     snippets/yy-quiz-markup.liquid, saa Translate & Adapt kan oversaette dem. */
  function T(key){ var d = window.YYQ_T || {}; return d[key] != null ? String(d[key]) : key; }

  var DEFAULT_ENDPOINT =
    "https://yurkyuiflxssoxgzocai.supabase.co/functions/v1/klub?action=club_quiz";

  function endpoint(){
    return window.YY_CLUB_QUIZ_ENDPOINT || DEFAULT_ENDPOINT;
  }

  /* Stilen bor her frem for i yy-quiz.css, saa hele denne funktion er én
     fil at deploye og én fil at rulle tilbage. Kortets ramme (.gift, .btn,
     .skiplink, .fine) kommer stadig fra yy-quiz.css — herunder er kun det
     formularen selv tilfoejer. */
  var CSS = [
    /* Selektoren baerer basisklassen med vilje: yy-quiz.css indlaeses fra
       sektionen i <body> og ligger dermed EFTER denne injicerede <style> i
       <head>. Ved ens specificitet vinder den sidste, saa ".yyq .gift--lead"
       ville tabe til ".yyq .gift". ".yyq .gift.gift--lead" vinder uanset
       raekkefoelge. */
    ".yyq .gift.gift--lead{display:grid;grid-template-columns:190px 1fr;gap:0;",
    "align-items:stretch;padding:0;overflow:hidden;border-radius:20px}",
    ".yyq .gift.gift--lead>.gift__media{position:relative;background:rgba(0,0,0,.18);",
    "display:flex;align-items:center;justify-content:center}",
    ".yyq .gift--lead .gift__media img{display:block;width:100%;height:100%;object-fit:cover}",
    ".yyq .gift.gift--lead>.gift__col{padding:22px 24px 20px;min-width:0}",
    /* I pop-up-rammen er .gift en sticky bundbjaelke. Kortet staar nu
       oeverst i resultatet, saa den forankring skal slaas fra, ellers
       klaeber gaven til bunden af et kort den ikke laengere ligger i. */
    ".yyq[data-frame=\"popup\"] .gift.gift--lead{position:static;margin-left:0;",
    "margin-right:0;box-shadow:none}",
    ".yyq .lead__row{display:flex;flex-wrap:wrap;gap:10px;margin:14px 0 0}",
    ".yyq .lead__f{flex:1 1 190px;min-width:0;display:block}",
    ".yyq .lead__f span{display:block;font-size:12px;font-weight:600;color:#dbe7dc;margin:0 0 5px}",
    ".yyq .lead__f input{width:100%;box-sizing:border-box;padding:13px 14px;border-radius:12px;",
    "border:1.5px solid rgba(255,255,255,.35);background:#fff;color:#1a1812;font:inherit;font-size:16px}",
    ".yyq .lead__f input:focus{outline:2.5px solid var(--gold);outline-offset:2px}",
    ".yyq .lead__f input[aria-invalid=\"true\"]{border-color:#f2b8a6}",
    ".yyq .gift--lead .btn{margin-top:12px;width:100%}",
    ".yyq .gift--lead .btn[disabled]{opacity:.65;cursor:default}",
    ".yyq .lead__err{margin:10px 0 0;font-size:13.5px;color:#ffd9cd;font-weight:600}",
    ".yyq .lead__fine{margin:12px 0 0;font-size:12.5px;color:#c5d6c7;line-height:1.45}",
    ".yyq .gift--lead .skiplink{margin-top:14px;text-align:left}",
    ".yyq .lead__cond{margin:8px 0 0;font-size:12.5px;color:#f0d69a;font-weight:600}",
    ".yyq .lead__ok h3{margin:0 0 6px;font-size:17px;font-weight:700;color:#fff}",
    ".yyq .lead__ok p{margin:0;font-size:14px;color:#dbe7dc}",
    ".yyq .lead__ok a{color:#fff;font-weight:600;text-underline-offset:3px}",
    "@media(min-width:561px){.yyq .gift--lead .btn{width:auto;min-width:230px}}",
    /* Under 700px er der ikke plads til to soejler. Billedet bliver et lavt
       baand i toppen frem for at forsvinde, saa kortet beholder sit ansigt. */
    "@media(max-width:699px){.yyq .gift.gift--lead{grid-template-columns:1fr}",
    ".yyq .gift--lead .gift__media{aspect-ratio:16/7}",
    ".yyq .gift--lead .gift__col{padding:18px 18px 16px}}"
  ].join("");

  function injectCss(){
    if(document.getElementById("yy-quiz-lead-css")) return;
    var s = document.createElement("style");
    s.id = "yy-quiz-lead-css";
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  function el(tag, cls, text){
    var n = document.createElement(tag);
    if(cls) n.className = cls;
    if(text != null) n.appendChild(document.createTextNode(text));
    return n;
  }

  /* Bevidst konservativ, og bevidst den samme grovhed som backenden:
     praecis ét @, intet mellemrum, et domaene med punktum i. Formularen
     skal fange slaafejl, ikke afvise lovlige adresser. Den rigtige
     validering sker i backenden, som er den der kan stoles paa. */
  function validEmail(v){
    return /^[^\s@]+@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/.test(v);
  }

  var FEJL = {
    bad_email: T("e_email"),
    bad_name: T("e_name"),
    rate_limited: T("e_rate"),
    too_large: T("e_large"),
    create_failed: T("e_create")
  };
  var FEJL_GENEREL = T("e_generic");

  /* ---------- sporing ----------
     Meta faar sin Lead-haendelse direkte fra fbq() her i filen, saa
     sporingen virker uden at vente paa GTM. dataLayer-eventet skubbes
     stadig — det er nyttigt til GA4 og Google Ads — men der maa IKKE ligge
     et Meta Lead-tag paa det i GTM, for saa taeller haendelsen dobbelt.

     Match-noeglerne er hashet her i browseren frem for sendt i klartekst.
     Meta accepterer SHA-256 direkte, saa match quality er den samme, men
     raa mail ligger ikke i dataLayer hvor ethvert andet GTM-tag kan laese
     den. Navnene foelger Googles konvention (sha256_email_address), saa den
     samme user_data-blok kan foede baade Meta og Enhanced Conversions.

     Klaviyos identify() SKAL koere foerst: de anonyme Quiz Besvarelse- og
     Quiz Gennemfoert-haendelser knyttes til profilen i det oejeblik Klaviyo
     faar mailen, og de knyttes bagud.
     Alt er guardet: en annonceblokering maa ikke kunne vaelte formularen. */

  function uuid(){
    try{
      var b = new Uint8Array(16);
      crypto.getRandomValues(b);
      b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
      var h = []; for(var i=0;i<16;i++) h.push((b[i]+256).toString(16).slice(1));
      return h.slice(0,4).join("")+"-"+h.slice(4,6).join("")+"-"+h.slice(6,8).join("")
           + "-"+h.slice(8,10).join("")+"-"+h.slice(10,16).join("");
    }catch(e){
      return "yy-" + Date.now() + "-" + Math.random().toString(16).slice(2,10);
    }
  }

  function cookie(name){
    try{
      var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
      return m ? decodeURIComponent(m[2]) : "";
    }catch(e){ return ""; }
  }

  /* Stabilt foersteparts-besoegende-id. Skillens hoejest-vaegtede noegle:
     den binder ogsaa haendelser sammen for folk vi ellers intet ved om. */
  function visitorId(){
    try{
      var v = cookie("yy_vid");
      if(!v){
        v = uuid();
        document.cookie = "yy_vid=" + encodeURIComponent(v)
          + ";path=/;max-age=63072000;samesite=lax" + (location.protocol === "https:" ? ";secure" : "");
      }
      return v;
    }catch(e){ return ""; }
  }

  /* _fbc findes kun hvis brugeren er landet med et fbclid tidligere. Er den
     tom, men fbclid staar i URL'en nu, bygger vi den selv i Metas format. */
  function fbc(){
    var c = cookie("_fbc");
    if(c) return c;
    try{
      var m = location.search.match(/[?&]fbclid=([^&]+)/);
      return m ? ("fb.1." + Date.now() + "." + decodeURIComponent(m[1])) : "";
    }catch(e){ return ""; }
  }

  function sha256(v){
    var t = String(v == null ? "" : v).trim().toLowerCase();
    if(!t) return Promise.resolve("");
    try{
      if(!(window.crypto && crypto.subtle && crypto.subtle.digest)) return Promise.resolve("");
      return crypto.subtle.digest("SHA-256", new TextEncoder().encode(t)).then(function(buf){
        var a = new Uint8Array(buf), out = "";
        for(var i=0;i<a.length;i++) out += (a[i]+256).toString(16).slice(1);
        return out;
      })["catch"](function(){ return ""; });
    }catch(e){ return Promise.resolve(""); }
  }

  /* Simpel pixel-sporing: vi fyrer Lead direkte, saa den virker uden at
     vente paa et GTM-tag. eventID er med fra starten — uden den ville en
     senere CAPI-haendelse taelle den samme lead to gange, og det er
     billigere at have noeglen med nu end at bagudrette det.

     Advarsel til den der laeser det her senere: laeg IKKE ogsaa et Meta
     Lead-tag paa generate_lead i GTM. Ét af de to steder skal eje
     haendelsen, ellers taeller den dobbelt. */
  function metaPixel(eventId, h){
    try{
      if(typeof window.fbq !== "function") return;
      try{
        /* Avanceret matching. Meta genkender 64-tegns hex og hasher ikke
           igen. fbq("init") paa et allerede kendt pixel-id opdaterer kun
           matchdata: det opretter intet nyt pixel og fyrer ingen PageView.
           Kun ved praecis ét pixel — er der flere, ved vi ikke hvilket. */
        var ids = (window.fbq.instance && window.fbq.instance.pixelsByID)
          ? Object.keys(window.fbq.instance.pixelsByID) : [];
        if(ids.length === 1 && h.em){
          var m = { em: h.em };
          if(h.fn) m.fn = h.fn;
          if(h.ln) m.ln = h.ln;
          if(h.external_id) m.external_id = h.external_id;
          window.fbq("init", ids[0], m);
        }
      }catch(e){ /* matchdata er en bonus — Lead skal fyre uanset */ }
      window.fbq("track", "Lead", { content_name: "Quiz lead" }, { eventID: eventId });
    }catch(e){ /* sporing er sekundaer */ }
  }

  /* ============================================================
     Quiz_started — Metas custom event for paabegyndt quiz
     ============================================================
     Hvorfor den findes: indtil nu kunne vi kun se dem der GENNEMFOERTE
     og afleverede deres mail. Uden en start-haendelse er der ingen
     naevner, og "14 leads" kan lige saa godt vaere 14 ud af 30 som
     14 ud af 500. Quiz_started er den maaling.

     Naar den fyres: i det oejeblik brugeren faktisk ser foerste
     spoergsmaal. Ikke ved mount — pop-uppen ligger i DOM'en paa hver
     eneste side, saa mount ville taelle sidevisninger, ikke starter.

     De to rammer starter forskelligt, og derfor er der to indgange:
       pop-up : YYQuiz.notifyOpen(root), som sektionen kalder naar
                pop-uppen aabnes. Foerste spoergsmaal staar klar der.
       side   : klik paa introskaermens knap. Introskaermen er den
                eneste skaerm i motoren der bruger <h1> — resten bruger
                <h2> — saa den kan genkendes uden at motoren aendres.

     Én gang pr. session. Det goer Quiz_started til den rigtige naevner
     for Lead: ét menneske, ét forsoeg. Uden graensen ville en bruger
     der moeder pop-uppen paa fem sider taelle fem starter.

     Samme advarsel som ved Lead: laeg IKKE ogsaa et Meta-tag paa
     quiz_started i GTM. Ét sted skal eje haendelsen, ellers taeller
     den dobbelt. */

  var START_KEY = "yy_quiz_started";

  function startedAlready(){
    /* Fejler sessionStorage (privat browsing, blokeret lager), fyrer vi
       hellere haendelsen end at tie. En for meget er billigere end et
       hul i naevneren. */
    try{ return !!sessionStorage.getItem(START_KEY); }catch(e){ return false; }
  }

  function markStarted(id){
    try{ sessionStorage.setItem(START_KEY, id); }catch(e){ /* se ovenfor */ }
  }

  function metaStart(eventId, frame, extId){
    try{
      if(typeof window.fbq !== "function") return;
      try{
        /* Ved starten kender vi ingen mail. external_id er det eneste
           match-signal vi har, og det er samtidig det der binder denne
           haendelse sammen med den senere Lead fra samme browser. */
        var ids = (window.fbq.instance && window.fbq.instance.pixelsByID)
          ? Object.keys(window.fbq.instance.pixelsByID) : [];
        if(ids.length === 1 && extId) window.fbq("init", ids[0], { external_id: extId });
      }catch(e){ /* matchdata er en bonus — haendelsen skal fyre uanset */ }
      window.fbq("trackCustom", "Quiz_started", {
        content_name: "Mikroplast-quiz",
        quiz_frame: frame || null,
        quiz_version: "evergreen_v2"
      }, { eventID: eventId });
    }catch(e){ /* sporing er sekundaer */ }
  }

  /* Returnerer true hvis haendelsen faktisk blev fyret, false hvis den
     allerede er fyret i denne session. Motoren maa gerne kalde den
     direkte, hvis den en dag faar sit eget start-punkt. */
  function started(frame){
    if(startedAlready()) return false;
    var eventId = uuid();
    markStarted(eventId);

    try{
      if(window.klaviyo && typeof window.klaviyo.push === "function"){
        window.klaviyo.push(["track", "Quiz Startet", {
          ramme: frame || null,
          quiz_version: "evergreen_v2"
        }]);
      }
    }catch(e){ /* sporing er sekundaer */ }

    var fired = false;
    function fire(ext){
      if(fired) return;
      fired = true;
      metaStart(eventId, frame, ext);
      try{
        window.dataLayer = window.dataLayer || [];
        if(typeof window.dataLayer.push !== "function") return;
        var ud = {};
        if(ext) ud.external_id = ext;
        var p = cookie("_fbp"); if(p) ud.fbp = p;
        var c = fbc(); if(c) ud.fbc = c;
        window.dataLayer.push({
          event: "quiz_started",
          lead_source: "yy_quiz",
          /* Samme id skal med paa en fremtidig CAPI-haendelse. Meta
             deduplikerer paa event_name + event_id. */
          event_id: eventId,
          user_data: ud,
          quiz_frame: frame || null,
          quiz_version: "evergreen_v2"
        });
      }catch(e){ /* sporing er sekundaer */ }
    }

    /* to argumenter frem for .catch: saa kan fire() ikke naa at loebe
       to gange hvis then-kroppen selv kaster. */
    try{ sha256(visitorId()).then(fire, function(){ fire(""); }); }
    catch(e){ fire(""); }

    return true;
  }

  /* ---------- selvinstallation ----------
     Filen indlaeses med defer EFTER yy-quiz.js, og begge sektioner
     monterer foerst paa load. window.YYQuiz staar derfor klar her, og vi
     kan lukke os om notifyOpen uden at roere motoren — som selv ligger
     taet paa upload-loftet og helst skal staa uroert. */
  function hookPopup(){
    try{
      var Q = window.YYQuiz;
      if(!Q || typeof Q.notifyOpen !== "function" || Q.__yyStartHooked) return !!(Q && Q.__yyStartHooked);
      var orig = Q.notifyOpen;
      Q.notifyOpen = function(root){
        try{
          var frame = (root && root.getAttribute) ? (root.getAttribute("data-frame") || "popup") : "popup";
          started(frame);
        }catch(e){ /* sporing maa aldrig blokere aabningen */ }
        return orig.apply(this, arguments);
      };
      Q.__yyStartHooked = true;
      return true;
    }catch(e){ return false; }
  }

  function hookPage(){
    try{
      /* Capture-fasen er ikke til pynt: motorens egen klik-handler ligger
         paa knappen selv og kalder render(), som toemmer root. I bubble-
         fasen ville skaermen vaere vaek, og closest() give null. */
      document.addEventListener("click", function(ev){
        try{
          var t = ev.target;
          if(!t || t.nodeType !== 1 || !t.closest) return;
          var btn = t.closest("button.btn");
          if(!btn) return;
          var root = btn.closest("[data-yyq]");
          if(!root) return;
          var pane = btn.closest(".quiz__pane");
          if(!pane || !pane.querySelector("h1")) return;   /* kun introskaermen */
          started(root.getAttribute("data-frame") || "page");
        }catch(e){ /* sporing maa aldrig blokere knappen */ }
      }, true);
    }catch(e){ /* sporing er sekundaer */ }
  }

  hookPage();
  if(!hookPopup()){
    /* Skulle raekkefoelgen en dag skride, faar vi ét forsoeg mere. */
    try{ window.addEventListener("load", hookPopup); }catch(e){}
  }

  function track(ctx, email, firstName, lastName, eventId){
    try{
      if(window.klaviyo && typeof window.klaviyo.push === "function"){
        window.klaviyo.push(["identify", { "$email": email, "$first_name": firstName }]);
      }
    }catch(e){ /* sporing er sekundaer */ }

    var props = {};
    try{
      var src = ctx.props || {};
      for(var k in src){ if(Object.prototype.hasOwnProperty.call(src, k)) props[k] = src[k]; }
    }catch(e){ /* tom props er bedre end ingen haendelse */ }

    try{
      if(window.klaviyo && typeof window.klaviyo.push === "function"){
        window.klaviyo.push(["track", "Quiz Lead", props]);
      }
    }catch(e){ /* sporing er sekundaer */ }

    try{
      Promise.all([sha256(email), sha256(firstName), sha256(lastName), sha256(visitorId())])
        .then(function(h){
          window.dataLayer = window.dataLayer || [];
          if(typeof window.dataLayer.push !== "function") return;
          var ud = {};
          if(h[0]) ud.sha256_email_address = h[0];
          if(h[1]) ud.sha256_first_name = h[1];
          if(h[2]) ud.sha256_last_name = h[2];
          if(h[3]) ud.external_id = h[3];
          var p = cookie("_fbp"); if(p) ud.fbp = p;
          var c = fbc(); if(c) ud.fbc = c;

          /* Pixlen fyrer her frem for foer hashningen, saa den avancerede
             matching naar at komme med. Promise-kaeden kan ikke afvises:
             sha256() svarer tom streng ved fejl, saa Lead fyrer altid. */
          metaPixel(eventId, { em: h[0], fn: h[1], ln: h[2], external_id: h[3] });

          window.dataLayer.push({
            event: "generate_lead",
            lead_source: "yy_quiz",
            /* Samme id skal med paa en fremtidig CAPI-haendelse. Meta
               deduplikerer paa event_name + event_id. */
            event_id: eventId,
            user_data: ud,
            quiz_frame: ctx.frame || null,
            quiz_version: props.quiz_version || null,
            quiz_score: props.score != null ? props.score : null,
            quiz_hotspot_1: props.quiz_hotspot_1 || null,
            quiz_hotspot_2: props.quiz_hotspot_2 || null,
            quiz_hotspot_3: props.quiz_hotspot_3 || null,
            quiz_beskytter: props.quiz_beskytter || null,
            quiz_madpakker_uge: props.quiz_madpakker_uge || null
          });
        })["catch"](function(){ /* sporing er sekundaer */ });
    }catch(e){ /* sporing er sekundaer */ }
  }

  /* ---------- resultatet gemmes lokalt ----------
     Samme noegler som foer: klubportalen henter yy_quiz_pending efter
     login, og yy_quiz_done undertrykker pop-up'en i karensperioden. */
  function persist(ctx){
    try{
      var S = ctx.state || {};
      localStorage.setItem("yy_quiz_pending", JSON.stringify({
        cards: S.cards, who: S.who, freqIdx: S.freqIdx, boxesIdx: S.boxesIdx,
        score: ctx.score, hotspots: ctx.hotspots, ts: Date.now()
      }));
      if(ctx.doneKey) localStorage.setItem(ctx.doneKey, new Date().toISOString());
    }catch(e){ /* privat browsing — fortsaet alligevel */ }
  }

  function successView(ctx, email, firstName){
    var ok = el("div","lead__ok");
    ok.appendChild(el("h3", null, firstName ? T("ok_named").replace("[navn]", firstName) : T("ok")));
    ok.appendChild(el("p", null, T("ok_inbox").replace("[mail]", email)));
    var p2 = el("p", null, "");
    var a = el("a", null, T("go_club"));
    a.href = ctx.clubUrl || "/pages/klub";
    p2.appendChild(a);
    p2.style.marginTop = "8px";
    ok.appendChild(p2);
    return ok;
  }

  function block(ctx){
    if(!ctx) return null;
    injectCss();

    var wrap = el("div","gift gift--lead");

    /* Billedet har sin egen indstilling i temaeditoren (gift_image). Er den
       tom, laaner vi introbilledet, og findes heller ikke det, viser vi
       gaveikonet frem for et tomt hul. */
    var media = el("div","gift__media");
    function attr(n){ return (ctx.root && ctx.root.getAttribute) ? (ctx.root.getAttribute(n) || "") : ""; }
    var imgSrc = attr("data-gift-image") || attr("data-intro-image");
    if(imgSrc){
      var im = document.createElement("img");
      im.src = imgSrc; im.alt = "";
      media.appendChild(im);
    } else { media.appendChild(el("div","gift__ico","🎁")); }
    wrap.appendChild(media);

    var head = el("div","gift__col");
    head.appendChild(el("span","gift__t",T("secret")));
    head.appendChild(el("span","gift__s",T("secret_s")));
    wrap.appendChild(head);

    var form = document.createElement("form");
    form.className = "lead__form";
    form.setAttribute("novalidate","novalidate");

    var row = el("div","lead__row");

    var lName = el("label","lead__f");
    lName.appendChild(el("span", null, T("name")));
    var iName = document.createElement("input");
    iName.type = "text"; iName.name = "yy_lead_name"; iName.autocomplete = "given-name";
    iName.placeholder = T("name_ph"); iName.maxLength = 80;
    lName.appendChild(iName);

    var lMail = el("label","lead__f");
    lMail.appendChild(el("span", null, T("mail")));
    var iMail = document.createElement("input");
    iMail.type = "email"; iMail.name = "yy_lead_email"; iMail.autocomplete = "email";
    iMail.placeholder = "din@mail.dk"; iMail.maxLength = 254;
    /* inputmode holder mobiltastaturet paa mailen uden at laase os til
       browserens egen validering, som vi alligevel slaar fra. */
    iMail.setAttribute("inputmode","email");
    lMail.appendChild(iMail);

    row.appendChild(lName);
    row.appendChild(lMail);
    form.appendChild(row);

    var btn = el("button","btn btn--gold",T("unlock"));
    btn.type = "submit";
    form.appendChild(btn);

    var err = el("p","lead__err");
    err.setAttribute("role","alert");
    err.hidden = true;
    form.appendChild(err);

    var fine = el("p","lead__fine",
      T("consent_fine"));
    form.appendChild(fine);

    /* Betingelsen skal staa sammen med loeftet. Den laa kun i fallback-
       kortet, saa formular-varianten lovede en gave uden at sige hvad der
       laaser den op. */
    form.appendChild(el("p","lead__cond",
      T("gift_valid").replace("[min]", ctx.giftMin || "100")));

    head.appendChild(form);

    var skip = el("button","skiplink",T("skip"));
    skip.type = "button";
    skip.addEventListener("click", function(){
      if(wrap.parentNode) wrap.parentNode.removeChild(wrap);
    });
    head.appendChild(skip);

    function showErr(msg, field){
      err.textContent = msg;
      err.hidden = false;
      if(field){ field.setAttribute("aria-invalid","true"); field.focus(); }
    }
    function clearErr(){
      err.hidden = true;
      err.textContent = "";
      iName.removeAttribute("aria-invalid");
      iMail.removeAttribute("aria-invalid");
    }

    var sending = false;
    form.addEventListener("submit", function(ev){
      ev.preventDefault();
      if(sending) return;
      clearErr();

      var navn = (iName.value || "").trim();
      var mail = (iMail.value || "").trim();
      if(navn.length < 2) return showErr(T("e_name"), iName);
      if(!validEmail(mail)) return showErr(T("e_email"), iMail);

      sending = true;
      btn.disabled = true;
      btn.setAttribute("aria-busy","true");
      btn.textContent = T("sending");

      /* Ét id pr. indsendelse, delt mellem browser og en fremtidig
         server-side CAPI-haendelse. Uden det taeller Meta den samme lead to
         gange, saa snart serversiden kommer til. */
      var eventId = uuid();
      var payload = {
        name: navn,
        email: mail,
        score: ctx.score,
        hotspots: ctx.hotspots || [],
        answers: ctx.props || {},
        event_id: eventId,
        external_id: visitorId()
      };

      function fail(code){
        sending = false;
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
        btn.textContent = T("unlock");
        showErr(FEJL[code] || FEJL_GENEREL, code === "bad_email" ? iMail : null);
      }

      var req;
      try{ req = fetch(endpoint(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      }); }catch(e){ return fail(null); }

      req.then(function(r){
        return r.json().then(function(j){ return { status: r.status, body: j || {} }; },
                             function(){ return { status: r.status, body: {} }; });
      }).then(function(res){
        if(res.status < 200 || res.status >= 300 || !res.body.ok) return fail(res.body.error);

        var dele = navn.split(/\s+/);
        var first = res.body.first_name || dele[0];
        var last = dele.length > 1 ? dele.slice(1).join(" ") : "";
        persist(ctx);
        track(ctx, mail, first, last, eventId);

        head.removeChild(form);
        if(skip.parentNode) head.removeChild(skip);
        head.appendChild(successView(ctx, mail, first));
      })["catch"](function(){ fail(null); });
    });

    return wrap;
  }

  return { block: block, started: started };
})();
